export const LogoutRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.5 18L5.5 18L5.5 6L12.5 6'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M8.5 12L18.5 12' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M15.5 15L18.5 12L15.5 9' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
